module.exports = __webpack_public_path__ + "img/20200109160243747.e680a8fd.jpg";